module.exports = __webpack_public_path__ + "img/icon_newTotal.fa4382ad.svg";